import type { ChangeEvent } from '@brighterly/lib-core-types/ui/inputs/interfaces'
import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface EmailReturn {
  mode: ComputedRef<InputMode>
  setEmail: (event: ChangeEvent) => void
}

export const useEmail = (): EmailReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const mode = computed(() => getMode(tutorApplicationStore.showErrors && (!tutorApplicationStore.form.email || !tutorApplicationStore.form.emailValid)))

  const setEmail = (event: ChangeEvent) => {
    tutorApplicationStore.setField('email', event.value)
    tutorApplicationStore.setField('emailValid', event.valid)
  }

  return {
    mode,
    setEmail,
  }
}
